module.exports = __webpack_public_path__ + "img/image-02.68dac143.jpg";